export default __webpack_public_path__ + "static/media/promo-you-know-who_04.42b62244.jpg";